export default __webpack_public_path__ + "7d64e71288ddf73ff676ce47878a87fe.png";